import { Text } from '@dixa/lib-shared-habla';
import uniqBy from 'lodash/uniqBy';

import { AppState } from 'bootstrap.store';
import { useAppSelector } from 'utils/redux/useAppSelector';

import styles from '../../conversationHeaderMoreMenu.module.scss';

import { ConversationHeaderPastAssignee } from './components/pastAssignee/conversationHeaderPastAssignee';

export const ConversationHeaderPastAssignees = (): JSX.Element => {
  const { assignments, authors } = useAppSelector((state: AppState) => ({
    assignments: uniqBy(
      state.conversation.metaConversation.conversation.assignments,
      (assignment) => assignment.agent_id,
    ),
    authors: state.conversation.metaConversation.conversation.authors,
  }));
  return (
    <>
      <Text.Paragraph className={styles.sectionTitle} subdued>
        Past assignees
      </Text.Paragraph>

      {assignments?.length ? (
        assignments.map(
          (assignment) =>
            assignment.agent_id &&
            authors?.[assignment.agent_id] && (
              <ConversationHeaderPastAssignee
                key={assignment.agent_id}
                agent={authors?.[assignment.agent_id]}
              />
            ),
        )
      ) : (
        <Text.Paragraph className={styles.notFoundText} variant="1">
          No past assignees found
        </Text.Paragraph>
      )}
    </>
  );
};
